export default __webpack_public_path__ + "static/media/Elle 9781408340325.57e9c432.jpg";